import { render } from "./TemplateIsoRadioGroup.vue?vue&type=template&id=2c1df2d4&scoped=true"
import script from "./TemplateIsoRadioGroup.vue?vue&type=script&lang=js"
export * from "./TemplateIsoRadioGroup.vue?vue&type=script&lang=js"

import "./TemplateIsoRadioGroup.vue?vue&type=style&index=0&id=2c1df2d4&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1df2d4"]])

export default __exports__